import axios from "axios";

export const getRapidoReachSurveys = async ({ userId, ipAddress, city, countryLanguageCode, dateOfBirth, gender, zipCode }) => {
    const params = { userId, ipAddress, city, countryLanguageCode, dateOfBirth, gender, zipCode };
    console.log('[RapidoReach] request params:', params);
    const { data } = await axios.get('api/rapidoreachoffers', {
        headers: {
            "Content-Type": 'application/json'
        },
        params
    });
    console.log('[RapidoReach] response body:', data);
    return data;
};

// Normalizes a RapidoReach survey into the shape TopOffer/JackpotStrip use.
export const normalizeRapidoSurvey = (survey) => ({
    id: `rapido-${survey.SurveyNumber}`,
    title: survey?.Survey?.SurveyName || "RapidoReach Survey",
    href_new: survey.SurveyUrl,
    payout: Number(survey.Reward ?? 0),
    conversionRate: Number(survey.MatchingPercentage ?? 0),
    conversion_rate: Number(survey.MatchingPercentage ?? 0),
    statistics_rating_count: undefined,
    statistics_rating_avg: undefined,
    provider: "rapidoreach",
    loi: survey.LOI,
    _raw: survey,
});
